/**
 * WAT-12043 / YFH-AMP122 — accessible name for the Local / RSN info pill
 * rendered on ChannelRow and SvodChannelRow.
 *
 * The string leads with the visible pill text ("Local" / "RSN") to
 * satisfy WCAG 2.5.3 Label in Name — voice-control users saying "click
 * Local" or "click RSN" must be able to match the accessible name, and
 * "Regional Sports Network information" alone does not include the
 * visible "RSN".
 *
 * Extracted so ChannelRow and SvodChannelRow can't drift when the label
 * wording changes — they both used to inline the same ternary.
 */
export const channelInfoAriaLabel = (category?: string): string =>
  category === "LOCAL" ?
    "Local channel information" :
    "RSN, Regional Sports Network information";
